export default __webpack_public_path__ + "a856f3557edf81fa45463b41e071e012.pdf";